import React, { useState } from "react";
import { formatCreatedAt, getOptimizedImage } from "../utils/Universalfunctions";
import { deleteDoc, doc, increment, updateDoc } from "firebase/firestore";
import { db } from "../utils/firebase";
import { Fullscreen } from "@mui/icons-material";
import toasted from "../config/toasted";


const PromptCard = ({ data, onApprove }) => {


    const [expand, setExpand] = useState(false);
    const [view, setView] = useState(false);
    const [likesInput, setLikesInput] = useState(data?.likes || 0);


    const handleRejectSubmit = async (reason) => {
        await deleteDoc(doc(db, "prompts", data?.id));

        const userRef = doc(db, "users", data?.uid);
        await updateDoc(userRef, {
            prompt: increment(-1)
        });

    };

    const handleLikesUpdate = async () => {
        try {
            const promptRef = doc(db, "prompts", data?.id);

            await updateDoc(promptRef, {
                likes: Number(likesInput)
            });

            toasted.success("Likes updated successfully ✅");
        } catch (error) {
            console.error("Error updating likes:", error);
            alert("Failed to update likes ❌");
        }
    };



    const handleApprove = async () => {
        try {
            await handleLikesUpdate();   // pehle likes update
            await onApprove();           // phir approve
        } catch (error) {
            console.error("Approve error:", error);
        }
    };


    return (
        <>
            <div className="col-md-4">
                <div className="prompt-card">
                    <div className="img-sec">
                        <p><span className="model-tag">{data?.aiModel || "N/A"}</span></p>
                        <img
                            src={getOptimizedImage({
                                publicId: data?.imageUrl,
                            })}
                            alt="HeyPrompt"
                        />

                        <button type="button" onClick={() => setView(true)} className="btn">
                            <Fullscreen />
                        </button>
                    </div>

                    <div className="bookmarks">
                        <p className={data.visibility === "private" ? "bg-warning text-black" : "bg-info text-black"}><b>visibility</b> {data.visibility || "N/A"}</p>
                        <p><b>Layout</b> {data.layout || "N/A"}</p>
                        <p> {formatCreatedAt(data.createdAt)}</p>
                        <p> {data?.likes || 0} Likes</p>
                    </div>

                    <div className="info-sec">
                        <h3>{data.title}</h3>
                        <p><b>Prompt ID:</b> {data.id || "N/A"}</p>
                        <p><b>UserID:</b> {data.userId || data.userid || "N/A"}</p>
                        <p><b>UserName:</b> @{data.username || "N/A"}</p>
                        <p><b>Category:</b> {data.category || "N/A"}</p>
                        <p><b>promptSource:</b> {data.promptSource || "N/A"}</p>
                        <div style={{ marginBottom: "10px" }}>
                            <b>Edit Likes:</b>
                            <input
                                type="number"
                                value={likesInput}
                                onChange={(e) => setLikesInput(e.target.value)}
                                style={{
                                    width: "80px",
                                    marginLeft: "8px",
                                    padding: "4px"
                                }}
                            />
                        </div>

                        <p style={{ borderBottom: '0' }}>
                            <b>Prompt:</b>  {!expand ? data.promptText.slice(0, 120) + "..." : data.promptText}
                            <span className="toggle" onClick={() => setExpand(!expand)}>
                                {expand ? " Show Less" : " Show More"}
                            </span>
                        </p>

                        <div className="actions">
                            <button className="reject-btn" onClick={handleRejectSubmit}>Delete</button>

                            <button className="approve-btn" onClick={handleApprove}>
                                Approve & Update
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {view && (
                <div className="fullView" onClick={() => setView(false)}>
                    <img src={getOptimizedImage({
                        publicId: data?.imageUrl,
                    })}
                        alt="Prompt Artwork full view" />
                </div>
            )}
        </>
    );
};

export default PromptCard;
